import { useState, useEffect } from "react";
import logomark from "./assets/logomark.png";
import fotoDiego from "./assets/diego.png";
import fotoGiovane from "./assets/giovane.png";
import thumbPedeclinica from "./assets/thumb-pedeclinica.jpg";
import thumbEliaquim from "./assets/thumb-eliaquim.png";
import thumbRockdoido from "./assets/thumb-rockdoido.png";
import Navbar from "./Navbar";
import LogoAppIcon from "./LogoAppIcon";
import {
  SiHtml5,
  SiCss,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiFlutter,
  SiAngular,
  SiNodedotjs,
  SiExpress,
  SiNestjs,
  SiOpenjdk,
  SiSpring,
  SiMongodb,
  SiPostgresql,
  SiSass,
  SiTailwindcss,
  SiJest,
  SiTestinglibrary,
  SiDocker,
  SiGooglecloud,
  SiGit,
  SiFigma,
  SiMercadopago,
} from "react-icons/si";
import { FaAws, FaRocket, FaLayerGroup, FaCompass, FaSearch, FaPencilRuler, FaCheckCircle, FaArrowRight, FaInstagram, FaGithub, FaLinkedinIn, FaFlag, FaCode, FaGlobeAmericas, FaHeartbeat, FaCashRegister, FaShoppingCart, FaUtensils, FaGraduationCap, FaBuilding } from "react-icons/fa";

function App() {
  const services = [
    {
      title: "Desenvolvimento sob medida",
      description:
        "Criamos sistemas web personalizados para automatizar processos e escalar o seu negócio.",
      icon: FaLayerGroup,
      tag: "Sistemas & APIs",
      accent: "from-brand-500 to-brand-400",
      iconBg: "bg-brand-500/15 text-brand-300 group-hover:bg-brand-500/25",
      border: "hover:border-brand-400/50",
      glow: "group-hover:shadow-[0_4px_32px_-4px_rgba(111,60,255,0.35)]",
    },
    {
      title: "Landing pages de alta conversão",
      description:
        "Construímos páginas rápidas, modernas e orientadas a resultado para geração de leads.",
      icon: FaRocket,
      tag: "Web & Marketing",
      accent: "from-accent-500 to-accent-400",
      iconBg: "bg-accent-500/15 text-accent-300 group-hover:bg-accent-500/25",
      border: "hover:border-accent-400/50",
      glow: "group-hover:shadow-[0_4px_32px_-4px_rgba(0,212,176,0.3)]",
    },
    {
      title: "Consultoria e evolução contínua",
      description:
        "Ajudamos você a decidir a melhor arquitetura, stack e roadmap de produto.",
      icon: FaCompass,
      tag: "Estratégia & Produto",
      accent: "from-violet-500 to-brand-400",
      iconBg: "bg-violet-500/15 text-violet-300 group-hover:bg-violet-500/25",
      border: "hover:border-violet-400/50",
      glow: "group-hover:shadow-[0_4px_32px_-4px_rgba(139,92,246,0.35)]",
    },
  ];

  const process = [
    {
      step: "01",
      title: "Imersão no seu negócio",
      text: "Entendemos objetivos, dores e oportunidades para definir a solução ideal.",
      icon: FaSearch,
      color: "text-brand-300",
      bg: "bg-brand-500/15",
      glow: "group-hover:shadow-[0_0_24px_-4px_rgba(111,60,255,0.4)]",
      border: "hover:border-brand-400/40",
    },
    {
      step: "02",
      title: "Design + desenvolvimento ágil",
      text: "Construímos interfaces modernas com ciclos curtos de validação e melhoria.",
      icon: FaPencilRuler,
      color: "text-accent-300",
      bg: "bg-accent-500/15",
      glow: "group-hover:shadow-[0_0_24px_-4px_rgba(0,212,176,0.35)]",
      border: "hover:border-accent-400/40",
    },
    {
      step: "03",
      title: "Entrega, suporte e evolução",
      text: "Publicamos, monitoramos e evoluímos o produto para sustentar crescimento.",
      icon: FaCheckCircle,
      color: "text-violet-300",
      bg: "bg-violet-500/15",
      glow: "group-hover:shadow-[0_0_24px_-4px_rgba(139,92,246,0.4)]",
      border: "hover:border-violet-400/40",
    },
  ];

  const metrics = [
    { value: "24h", label: "para retorno inicial" },
    { value: "100%", label: "projetos sob medida" },
    { value: "NPS 9+", label: "atendimento consultivo" },
  ];

  const timeline = [
    {
      year: "2026",
      label: "Origem",
      title: "Fundação e posicionamento",
      summary: "Nascemos com propósito claro: código de qualidade a serviço de negócios reais.",
      detail: "Diego e Giovane uniram suas expertises em back-end, mobile e front-end para criar uma software house enxuta, técnica e próxima do cliente. Desde o início, a proposta foi simples: entregar produto — não somente linhas de código.",
      highlights: ["Software house fundada em Ananindeua/PA", "Dois cofundadores, múltiplas especialidades", "Foco em sistemas web, apps e landing pages"],
      icon: FaFlag,
      accent: "from-brand-500 to-brand-400",
      iconBg: "bg-brand-500/15 text-brand-300",
      border: "hover:border-brand-400/40",
      glow: "group-hover:shadow-[0_8px_32px_-4px_rgba(111,60,255,0.4)]",
      dot: "bg-brand-400",
    },
    {
      year: "Agora",
      label: "Presente",
      title: "Entrega orientada a resultado",
      summary: "Projetos reais no ar, clientes satisfeitos e stack moderna em constante evolução.",
      detail: "Cada projeto passa por imersão, prototipação, desenvolvimento ágil e deploy acompanhado. Usamos as melhores ferramentas do mercado — React, Node.js, Flutter, TypeScript — sempre com engenharia limpa e cobertura de testes.",
      highlights: ["Portfólio com produtos publicados e em uso", "Stack moderna: React, Node, Flutter, TypeScript", "Ciclos curtos de entrega com validação contínua"],
      icon: FaCode,
      accent: "from-accent-500 to-accent-400",
      iconBg: "bg-accent-500/15 text-accent-300",
      border: "hover:border-accent-400/40",
      glow: "group-hover:shadow-[0_8px_32px_-4px_rgba(0,212,176,0.35)]",
      dot: "bg-accent-400",
    },
    {
      year: "Próximo passo",
      label: "Futuro",
      title: "Escala com parceiros",
      summary: "Mais produtos, mais segmentos e parcerias estratégicas para crescer junto.",
      detail: "A meta é ampliar o portfólio com produtos SaaS próprios, firmar parcerias com agências e empresas de diferentes segmentos, e continuar evoluindo a stack para entregar ainda mais valor com menos atrito.",
      highlights: ["Expansão para produtos SaaS próprios", "Parcerias com agências e empresas", "Novos segmentos: saúde, educação e varejo"],
      icon: FaGlobeAmericas,
      accent: "from-violet-500 to-brand-400",
      iconBg: "bg-violet-500/15 text-violet-300",
      border: "hover:border-violet-400/40",
      glow: "group-hover:shadow-[0_8px_32px_-4px_rgba(139,92,246,0.4)]",
      dot: "bg-violet-400",
    },
  ];

  const portfolio = [
    {
      name: "Pedeclinica",
      url: "https://pedeclinica.com.br",
      tag: "Landing Page · Saúde",
      thumb: thumbPedeclinica,
      thumbFit: "object-cover",
      iconBg: "",
      glowColor: "bg-teal-500/25",
      text: "Landing page para clínica de podologia em Ananindeua/PA — foco em conversão, agendamento pelo WhatsApp e credibilidade clínica.",
      stack: ["React", "Tailwind CSS", "SEO"],
      badge: null,
    },
    {
      name: "Dr. Eliaquim",
      url: "https://www.eliaquimdr.com",
      tag: "Landing Page · Odontologia",
      thumb: thumbEliaquim,
      thumbFit: "object-contain p-3",
      iconBg: "bg-white",
      glowColor: "bg-blue-400/25",
      text: "Site profissional para cirurgião-dentista especialista em estética dental — galeria de transformações, diferenciais e captação de consultas.",
      stack: ["React", "Animações", "Galeria"],
      badge: null,
    },
    {
      name: "RockDoido",
      url: "https://apps.apple.com/br/app/rockdoido/id1479712940",
      tag: "App · Música & Entretenimento",
      thumb: thumbRockdoido,
      thumbFit: "object-cover",
      iconBg: "",
      glowColor: "bg-brand-500/25",
      text: "O app de música mais animado da região Norte do Brasil. Reúne os melhores lançamentos de aparelhagens, DJs e sets exclusivos, permitindo ouvir ou baixar direto no celular. Mais de 150 avaliações com nota 4,7 na App Store.",
      stack: ["React Native", "Streaming", "Música"],
      badge: "⭐ 4,7 na App Store",
    },
  ];

  const stackCategories = [
    {
      category: "Linguagens base",
      accent: "from-yellow-400/20 to-orange-400/10",
      border: "border-yellow-400/30",
      items: [
        { name: "HTML5", icon: SiHtml5, color: "text-orange-400", desc: "Estrutura semântica e acessível para toda experiência web moderna." },
        { name: "CSS3", icon: SiCss, color: "text-blue-400", desc: "Estilização avançada com animações, grids e design responsivo nativo." },
        { name: "JavaScript", icon: SiJavascript, color: "text-yellow-400", desc: "A linguagem universal da web — versátil, rápida e presente em toda a stack." },
        { name: "TypeScript", icon: SiTypescript, color: "text-blue-300", desc: "JavaScript tipado para código mais seguro, escalável e fácil de manter." },
      ],
    },
    {
      category: "Front-end & Mobile",
      accent: "from-cyan-400/20 to-brand-500/10",
      border: "border-cyan-400/30",
      items: [
        { name: "React", icon: SiReact, color: "text-cyan-400", desc: "Interfaces modernas e reativas com componentização eficiente e ecossistema maduro." },
        { name: "Next.js", icon: SiNextdotjs, color: "text-white", desc: "Framework React para SSR, SSG e rotas avançadas com performance de ponta." },
        { name: "React Native", icon: SiReact, color: "text-cyan-300", desc: "Apps para iOS e Android com código compartilhado e performance nativa." },
        { name: "Flutter", icon: SiFlutter, color: "text-sky-400", desc: "SDK do Google para apps multiplataforma com UI rica e compilação nativa." },
        { name: "Angular", icon: SiAngular, color: "text-red-400", desc: "Framework robusto para SPAs corporativas com arquitetura estruturada." },
      ],
    },
    {
      category: "Back-end",
      accent: "from-green-400/20 to-emerald-500/10",
      border: "border-green-400/30",
      items: [
        { name: "Node.js", icon: SiNodedotjs, color: "text-green-400", desc: "Runtime JavaScript no servidor para APIs rápidas, escaláveis e de baixa latência." },
        { name: "Express", icon: SiExpress, color: "text-slate-300", desc: "Framework minimalista para construção ágil de APIs RESTful em Node.js." },
        { name: "NestJS", icon: SiNestjs, color: "text-red-400", desc: "Framework Node.js com arquitetura limpa, DI e suporte a TypeScript nativo." },
        { name: "Java", icon: SiOpenjdk, color: "text-orange-300", desc: "Linguagem consolidada para sistemas empresariais de alta disponibilidade." },
        { name: "Spring Boot", icon: SiSpring, color: "text-green-300", desc: "Ecossistema Java para back-ends robustos, seguros e prontos para produção." },
      ],
    },
    {
      category: "Banco de dados",
      accent: "from-emerald-400/20 to-teal-500/10",
      border: "border-emerald-400/30",
      items: [
        { name: "MongoDB", icon: SiMongodb, color: "text-emerald-400", desc: "NoSQL flexível para dados não estruturados e sistemas que precisam escalar rápido." },
        { name: "PostgreSQL", icon: SiPostgresql, color: "text-blue-400", desc: "Banco relacional robusto com suporte a transações, joins complexos e alta consistência." },
      ],
    },
    {
      category: "Estilo & Design",
      accent: "from-pink-400/20 to-purple-500/10",
      border: "border-pink-400/30",
      items: [
        { name: "Tailwind CSS", icon: SiTailwindcss, color: "text-sky-400", desc: "Framework utilitário para interfaces consistentes e responsivas com agilidade real." },
        { name: "SASS", icon: SiSass, color: "text-pink-400", desc: "Pré-processador CSS com variáveis, mixins e modularização para projetos grandes." },
        { name: "Figma", icon: SiFigma, color: "text-violet-400", desc: "Prototipagem e design colaborativo com foco em UI/UX e entrega precisa para dev." },
      ],
    },
    {
      category: "Testes & Qualidade",
      accent: "from-rose-400/20 to-red-500/10",
      border: "border-rose-400/30",
      items: [
        { name: "Jest", icon: SiJest, color: "text-rose-400", desc: "Framework de testes unitários e integração para JavaScript com cobertura completa." },
        { name: "Testing Library", icon: SiTestinglibrary, color: "text-red-300", desc: "Testes orientados ao comportamento do usuário para componentes React e DOM." },
      ],
    },
    {
      category: "Cloud & DevOps",
      accent: "from-sky-400/20 to-blue-500/10",
      border: "border-sky-400/30",
      items: [
        { name: "AWS", icon: FaAws, color: "text-orange-300", desc: "EC2, S3 e Lambda para hospedagem, armazenamento e funções serverless escaláveis." },
        { name: "Google Cloud", icon: SiGooglecloud, color: "text-blue-300", desc: "App Engine e serviços GCP para deploys gerenciados com alta disponibilidade." },
        { name: "Docker", icon: SiDocker, color: "text-sky-300", desc: "Containerização para garantir ambiente idêntico entre dev, staging e produção." },
        { name: "Git", icon: SiGit, color: "text-orange-400", desc: "Versionamento com histórico rastreável, branches e integração contínua." },
      ],
    },
    {
      category: "Integrações & Pagamentos",
      accent: "from-accent-500/20 to-teal-500/10",
      border: "border-accent-400/30",
      items: [
        { name: "Mercado Pago", icon: SiMercadopago, color: "text-cyan-300", desc: "Integração completa de checkout, Pix, boleto e assinaturas recorrentes." },
        { name: "APIs REST", icon: SiNodedotjs, color: "text-green-300", desc: "Integrações com Gerencianet, gateways de pagamento e qualquer API de mercado." },
      ],
    },
  ];

  const STACK_VISIBLE = 3;
  const [stackOpen, setStackOpen] = useState(false);
  const [activeTimeline, setActiveTimeline] = useState(0);
  const [typedLines, setTypedLines] = useState(0);

  const codeLines = [
    { segs: [
      { t: "import", c: "text-brand-400" },
      { t: " { Solution } ", c: "text-slate-300" },
      { t: "from", c: "text-brand-400" },
      { t: " 'c&e-developers'", c: "text-green-300" },
    ]},
    { segs: [] },
    { segs: [
      { t: "const", c: "text-brand-400" },
      { t: " projeto ", c: "text-slate-200" },
      { t: "=", c: "text-slate-500" },
      { t: " Solution({", c: "text-slate-300" },
    ]},
    { segs: [
      { t: "  cliente", c: "text-sky-300" },
      { t: ":  ", c: "text-slate-500" },
      { t: "'Sua empresa'", c: "text-accent-300" },
      { t: ",", c: "text-slate-500" },
    ]},
    { segs: [
      { t: "  stack", c: "text-sky-300" },
      { t: ":    [", c: "text-slate-500" },
      { t: "'React'", c: "text-accent-300" },
      { t: ", ", c: "text-slate-500" },
      { t: "'Node.js'", c: "text-accent-300" },
      { t: ", ", c: "text-slate-500" },
      { t: "'TypeScript'", c: "text-accent-300" },
      { t: "],", c: "text-slate-500" },
    ]},
    { segs: [
      { t: "  prazo", c: "text-sky-300" },
      { t: ":    ", c: "text-slate-500" },
      { t: "'sob medida'", c: "text-green-300" },
      { t: ",", c: "text-slate-500" },
    ]},
    { segs: [
      { t: "  escala", c: "text-sky-300" },
      { t: ":   ", c: "text-slate-500" },
      { t: "Infinity", c: "text-yellow-300" },
      { t: ",", c: "text-slate-500" },
    ]},
    { segs: [{ t: "})", c: "text-slate-300" }] },
    { segs: [] },
    { segs: [
      { t: "export", c: "text-brand-400" },
      { t: " default ", c: "text-slate-300" },
      { t: "projeto", c: "text-sky-200" },
    ]},
  ];

  useEffect(() => {
    if (typedLines >= codeLines.length) return;
    const t = setTimeout(() => setTypedLines((n) => n + 1), 120);
    return () => clearTimeout(t);
  }, [typedLines, codeLines.length]);

  const team = [
    {
      name: "Diego",
      role: "Desenvolvedor & Co-fundador",
      quote: "Arquitetura limpa não é luxo, é o fundamento de um produto que vai durar e crescer.",
      photo: fotoDiego,
      tags: ["Backend", "Node.js", "MongoDB"],
      instagram: "https://www.instagram.com/caiena.dev/",
      instagramHandle: "@caiena.dev",
      github: "https://github.com/DCaiena",
      githubHandle: "DCaiena",
      linkedin: "https://www.linkedin.com/in/diegocaiena",
    },
    {
      name: "Giovane",
      role: "Desenvolvedor & Co-fundador",
      quote: "A melhor solução técnica é aquela que o usuário nunca precisará perceber que existe.",
      photo: fotoGiovane,
      tags: ["Mobile", "React Native", "UI"],
      instagram: "https://www.instagram.com/giovane.yuri/",
      instagramHandle: "@giovane.yuri",
      github: "https://github.com/Yuriestumano",
      githubHandle: "Yuriestumano",
      linkedin: "https://www.linkedin.com/in/giovane-yuri/",
    },
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-night-900 text-slate-100">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-40 left-1/2 h-[32rem] w-[32rem] -translate-x-1/2 rounded-full bg-brand-600/35 blur-3xl" />
        <div className="absolute -left-28 top-[28rem] h-72 w-72 rounded-full bg-brand-400/25 blur-3xl" />
        <div className="absolute -right-20 top-80 h-80 w-80 rounded-full bg-accent-500/25 blur-3xl" />
      </div>

      <Navbar />

      <main className="mx-auto w-full max-w-6xl px-6 pb-16 pt-24">
        <section id="hero" className="scroll-mt-20 grid gap-10 py-16 md:grid-cols-2 md:items-center">
          <div>
            <div className="group mb-6 inline-flex">
              <LogoAppIcon
                src={logomark}
                alt="Marca C&E Developers"
                className="h-[5rem] w-[5rem] sm:h-[5.5rem] sm:w-[5.5rem] md:h-[6rem] md:w-[6rem]"
              />
            </div>
            <p className="mb-4 inline-flex rounded-full border border-brand-400/50 bg-brand-500/15 px-4 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-brand-100">
              Software house
            </p>
            <h1 className="text-4xl font-bold leading-tight md:text-5xl">
              Desenvolvimento e programação para empresas que querem crescer com tecnologia
            </h1>
            <p className="mt-5 max-w-xl text-base text-slate-300 md:text-lg">
              Projetamos, desenvolvemos e evoluímos sistemas web, landing pages e soluções digitais
              com foco em performance, escalabilidade e resultado de negócio.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                className="rounded-full bg-gradient-to-r from-brand-500 via-brand-400 to-accent-500 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-brand-700/30 transition hover:brightness-110"
                href="https://wa.me/559183423638"
                target="_blank"
                rel="noopener noreferrer"
              >
                Solicitar proposta
              </a>
              <a
                className="rounded-full border border-accent-500/40 bg-night-800/60 px-6 py-3 text-sm font-semibold text-accent-300 transition hover:border-accent-400 hover:text-accent-200"
                href="#servicos"
              >
                Ver serviços
              </a>
            </div>
            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {metrics.map((metric, index) => (
                <div key={metric.value} className="rounded-xl border border-night-700 bg-night-800/70 px-4 py-3">
                  <p className={`text-xl font-bold ${index % 2 === 0 ? "text-brand-300" : "text-accent-300"}`}>
                    {metric.value}
                  </p>
                  <p className="text-xs text-slate-400">{metric.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-2xl border border-night-700 bg-night-900
                          shadow-[0_0_40px_-8px_rgba(111,60,255,0.35)]
                          transition-all duration-500
                          hover:-translate-y-1
                          hover:border-brand-400/50
                          hover:shadow-[0_0_64px_-8px_rgba(111,60,255,0.6),0_0_32px_-8px_rgba(0,212,176,0.25)]">

            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-brand-600/5 via-transparent to-accent-500/5 opacity-0 transition-opacity duration-500 group-hover:opacity-100 pointer-events-none" />

            <div className="flex items-center gap-2 border-b border-night-700 bg-night-800/80 px-4 py-3 transition-colors duration-300 group-hover:bg-night-800/95">
              <span className="h-3 w-3 rounded-full bg-red-500/80 transition-all duration-300 group-hover:bg-red-400 group-hover:shadow-[0_0_6px_rgba(239,68,68,0.7)]" />
              <span className="h-3 w-3 rounded-full bg-yellow-400/80 transition-all duration-300 group-hover:bg-yellow-300 group-hover:shadow-[0_0_6px_rgba(250,204,21,0.7)]" />
              <span className="h-3 w-3 rounded-full bg-green-500/80 transition-all duration-300 group-hover:bg-green-400 group-hover:shadow-[0_0_6px_rgba(74,222,128,0.7)]" />
              <span className="ml-3 font-mono text-xs text-slate-500 transition-colors duration-300 group-hover:text-slate-400">
                projeto.ts — C&E Developers
              </span>
              <span className="ml-auto rounded border border-accent-400/30 bg-accent-500/10 px-2 py-0.5 text-xs text-accent-300 transition-all duration-300 group-hover:border-accent-400/60 group-hover:bg-accent-500/20 group-hover:text-accent-200">
                ✓ Compilado com sucesso
              </span>
            </div>

            <div className="p-5 font-mono text-sm leading-7">
              {codeLines.map((line, i) => (
                <div
                  key={i}
                  className={`group/line flex gap-4 rounded px-1 transition-all duration-300 hover:bg-night-800/60 ${i < typedLines ? "opacity-100" : "opacity-0"}`}
                >
                  <span className="w-5 shrink-0 select-none text-right text-xs text-slate-600 transition-colors duration-200 group-hover/line:text-slate-500">
                    {line.segs.length > 0 ? i + 1 : ""}
                  </span>
                  <span className="whitespace-pre transition-all duration-200 group-hover/line:brightness-110">
                    {line.segs.length > 0
                      ? line.segs.map((seg, j) => (
                          <span key={j} className={seg.c}>{seg.t}</span>
                        ))
                      : "\u00A0"}
                  </span>
                </div>
              ))}

              <div className={`flex gap-4 px-1 transition-opacity duration-300 ${typedLines >= codeLines.length ? "opacity-100" : "opacity-0"}`}>
                <span className="w-5 shrink-0 select-none text-right text-xs text-slate-600" />
                <span className="inline-block h-5 w-2.5 animate-pulse bg-accent-400 shadow-[0_0_8px_rgba(0,212,176,0.6)]" />
              </div>
            </div>

            <div className="border-t border-night-700 bg-night-800/50 px-5 py-3 transition-colors duration-300 group-hover:bg-night-800/80">
              <div className="flex items-center gap-2 text-xs text-slate-500">
                <span className="h-2 w-2 rounded-full bg-accent-400 shadow-[0_0_6px_rgba(0,212,176,0.5)]" />
                TypeScript · ESNext · C&E Developers
              </div>
            </div>

            <div className="pointer-events-none absolute right-0 top-0 h-full w-32 bg-gradient-to-l from-brand-600/10 to-transparent transition-opacity duration-500 group-hover:opacity-150" />
          </div>
        </section>

        <section id="servicos" className="scroll-mt-20 py-12">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-brand-400/40 bg-brand-500/10 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-brand-300">
            O que entregamos
          </p>
          <h2 className="text-3xl font-bold">Soluções para tirar projetos do papel</h2>
          <p className="mt-3 max-w-2xl text-slate-300">
            Do primeiro wireframe ao deploy em produção — construímos, lado a lado com você, cada etapa do produto digital.
          </p>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <article
                  key={service.title}
                  className={`group relative overflow-hidden rounded-2xl border border-night-700 bg-night-800/70 p-6 transition-all duration-300 hover:-translate-y-1 ${service.border} ${service.glow}`}
                >
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                  <div className="mb-5 flex items-start justify-between">
                    <div className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl transition-all duration-300 ${service.iconBg}`}>
                      <Icon />
                    </div>
                    <span className="rounded-full border border-night-700 bg-night-900/80 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400 transition-colors duration-300 group-hover:text-slate-300">
                      {service.tag}
                    </span>
                  </div>

                  <div className={`mb-4 h-0.5 w-10 rounded-full bg-gradient-to-r transition-all duration-300 group-hover:w-16 ${service.accent}`} />

                  <h3 className="text-lg font-semibold leading-snug">{service.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-300">{service.description}</p>
                </article>
              );
            })}
          </div>
        </section>

        <section className="scroll-mt-20 py-12">
          <div className="mb-10 text-center">
            <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1 font-mono text-xs font-semibold text-accent-300">
              Para quem é?_
            </p>
            <h2 className="text-3xl font-bold">
              Independente do seu segmento,<br className="hidden md:block" /> a C&E Developers é para você
            </h2>
            <p className="mt-3 text-slate-400">
              Atendemos negócios de todos os portes que querem usar tecnologia para crescer, organizar e vender mais.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {[
              {
                icon: FaHeartbeat,
                title: "Clínicas e consultórios",
                description: "Agendamento online, prontuário digital, landing page de captação de pacientes e integração com WhatsApp.",
                tags: ["Odontologia", "Psicologia", "Estética", "Medicina"],
                color: "text-rose-300",
                bg: "bg-rose-500/10",
                border: "hover:border-rose-400/40",
                glow: "hover:shadow-[0_4px_24px_-4px_rgba(244,63,94,0.3)]",
              },
              {
                icon: FaCashRegister,
                title: "Comércio e PDV",
                description: "Sistemas de ponto de venda, controle de estoque, relatórios e painel administrativo para seu negócio.",
                tags: ["Varejo", "Mercado", "Farmácia", "Pet shop"],
                color: "text-amber-300",
                bg: "bg-amber-500/10",
                border: "hover:border-amber-400/40",
                glow: "hover:shadow-[0_4px_24px_-4px_rgba(245,158,11,0.3)]",
              },
              {
                icon: FaShoppingCart,
                title: "E-commerce e lojas virtuais",
                description: "Loja online com carrinho, pagamento integrado (Mercado Pago, Pix) e painel de pedidos fácil de gerenciar.",
                tags: ["Moda", "Eletrônicos", "Artesanato", "Cosméticos"],
                color: "text-brand-300",
                bg: "bg-brand-500/10",
                border: "hover:border-brand-400/40",
                glow: "hover:shadow-[0_4px_24px_-4px_rgba(111,60,255,0.3)]",
              },
              {
                icon: FaUtensils,
                title: "Restaurantes e alimentação",
                description: "Cardápio digital com QR code, pedidos online, controle de mesas e integração com apps de delivery.",
                tags: ["Restaurante", "Lanchonete", "Cafeteria", "Confeitaria"],
                color: "text-orange-300",
                bg: "bg-orange-500/10",
                border: "hover:border-orange-400/40",
                glow: "hover:shadow-[0_4px_24px_-4px_rgba(249,115,22,0.3)]",
              },
              {
                icon: FaGraduationCap,
                title: "Educação e cursos",
                description: "Plataformas de aulas, área do aluno, vendas de cursos, certificados automáticos e gestão de turmas.",
                tags: ["Escolas", "Cursos online", "Coaching", "Idiomas"],
                color: "text-accent-300",
                bg: "bg-accent-500/10",
                border: "hover:border-accent-400/40",
                glow: "hover:shadow-[0_4px_24px_-4px_rgba(0,212,176,0.3)]",
              },
              {
                icon: FaBuilding,
                title: "Prestadores de serviço",
                description: "Site profissional, formulário de orçamento, portfólio de trabalhos e captação de clientes pelo Google.",
                tags: ["Advocacia", "Contabilidade", "Imobiliária", "Arquitetura"],
                color: "text-violet-300",
                bg: "bg-violet-500/10",
                border: "hover:border-violet-400/40",
                glow: "hover:shadow-[0_4px_24px_-4px_rgba(139,92,246,0.3)]",
              },
            ].map((niche) => {
              const Icon = niche.icon;
              return (
                <article
                  key={niche.title}
                  className={`group relative overflow-hidden rounded-2xl border border-night-700 bg-night-800/60 p-6 transition-all duration-300 hover:-translate-y-1 ${niche.border} ${niche.glow}`}
                >
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                  <div className={`mb-4 flex h-11 w-11 items-center justify-center rounded-xl text-xl transition-transform duration-300 group-hover:scale-110 ${niche.bg} ${niche.color}`}>
                    <Icon />
                  </div>

                  <h3 className="text-base font-semibold leading-snug">{niche.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{niche.description}</p>

                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {niche.tags.map((tag) => (
                      <span key={tag} className={`rounded-full border border-night-700 bg-night-900/70 px-2.5 py-0.5 text-[10px] font-medium text-slate-500`}>
                        {tag}
                      </span>
                    ))}
                  </div>
                </article>
              );
            })}
          </div>

          <div className="mt-8 rounded-2xl border border-accent-400/20 bg-accent-500/5 px-6 py-5 text-center">
            <p className="text-sm text-slate-300">
              Não encontrou seu segmento?{" "}
              <a href="#contato" className="font-semibold text-accent-300 underline-offset-2 hover:underline">
                Fale com a gente
              </a>{" "}
              — se envolve tecnologia, a gente resolve.
            </p>
          </div>
        </section>

        <section id="processo" className="scroll-mt-20 py-12">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-accent-300">
            Processo
          </p>
          <h2 className="text-3xl font-bold">Como trabalhamos</h2>
          <p className="mt-3 max-w-2xl text-slate-400">
            Cada projeto segue um fluxo claro e transparente — sem surpresas, com foco em resultado.
          </p>

          <div className="mt-10 flex flex-col gap-4 md:flex-row md:items-stretch md:gap-0">
            {process.map((item, idx) => {
              const Icon = item.icon;
              const isLast = idx === process.length - 1;
              return (
                <div key={item.step} className="flex flex-1 flex-col md:flex-row">
                  <article
                    className={`group relative flex-1 overflow-hidden rounded-2xl border border-night-700 bg-night-800/80 p-6 transition-all duration-300 hover:-translate-y-1 ${item.border} ${item.glow}`}
                  >
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                    <div className="mb-5 flex items-center justify-between">
                      <div className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl transition-all duration-300 ${item.bg} ${item.color}`}>
                        <Icon />
                      </div>
                      <span className={`text-4xl font-black opacity-10 transition-opacity duration-300 group-hover:opacity-20 ${item.color}`}>
                        {item.step}
                      </span>
                    </div>

                    <h3 className="text-lg font-semibold leading-snug">{item.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-400">{item.text}</p>
                  </article>

                  {!isLast && (
                    <div className="flex items-center justify-center py-2 md:px-3 md:py-0">
                      <FaArrowRight className="rotate-90 text-xl text-night-700 md:rotate-0" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>

        <section id="historia" className="scroll-mt-20 py-12">
          <div className="mb-10 text-center">
            <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-violet-400/40 bg-violet-500/10 px-4 py-1 font-mono text-xs font-semibold text-violet-300">
              Nossa jornada_
            </p>
            <h2 className="text-3xl font-bold">De onde viemos e para onde vamos</h2>
            <p className="mt-3 text-slate-400">
              Uma trajetória construída com propósito, técnica e foco em resultado real.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 md:items-stretch">
            <div className="flex flex-col gap-3">
              {timeline.map((item, idx) => {
                const Icon = item.icon;
                const isActive = activeTimeline === idx;
                return (
                  <button
                    key={item.title}
                    onClick={() => setActiveTimeline(idx)}
                    className={`group relative w-full overflow-hidden rounded-2xl border p-6 text-left transition-all duration-300 ${
                      isActive
                        ? `border-transparent bg-night-800 ${item.glow.replace("group-hover:", "")}`
                        : "border-night-700 bg-night-800/40 hover:border-night-600 hover:bg-night-800/70"
                    }`}
                  >
                    {isActive && (
                      <div className={`absolute left-0 top-0 h-full w-1 rounded-l-2xl bg-gradient-to-b ${item.accent}`} />
                    )}
                    <div className={`absolute left-0 top-0 h-0.5 bg-gradient-to-r transition-all duration-500 ${item.accent} ${isActive ? "w-full" : "w-0 group-hover:w-full"}`} />

                    <div className="flex items-center gap-4">
                      <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-lg transition-all duration-300 ${item.iconBg} ${isActive ? "scale-110" : ""}`}>
                        <Icon />
                      </div>
                      <div className="flex-1 text-left">
                        <div className="flex items-center gap-2">
                          <span className={`h-1.5 w-1.5 rounded-full ${item.dot}`} />
                          <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500">{item.year}</p>
                          <span className="ml-auto rounded-full border border-night-600 bg-night-900/70 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-slate-500">
                            {item.label}
                          </span>
                        </div>
                        <h3 className={`mt-1 text-base font-semibold transition-colors duration-200 ${isActive ? "text-white" : "text-slate-300"}`}>
                          {item.title}
                        </h3>
                      </div>
                    </div>

                    {isActive && (
                      <p className="mt-4 pl-[3.75rem] text-sm leading-relaxed text-slate-400 animate-[fadeIn_0.3s_ease]">
                        {item.summary}
                      </p>
                    )}
                  </button>
                );
              })}
            </div>

            <div className={`relative overflow-hidden rounded-2xl border border-night-700 bg-night-800/70 p-8 transition-all duration-500 ${timeline[activeTimeline].glow.replace("group-hover:", "")}`}>
              <div className={`absolute left-0 top-0 h-1 w-full bg-gradient-to-r ${timeline[activeTimeline].accent} transition-all duration-500`} />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent" />

              <div className="flex h-full flex-col justify-between">
                <div>
                  <div className={`mb-4 flex h-14 w-14 items-center justify-center rounded-2xl text-2xl ${timeline[activeTimeline].iconBg}`}>
                    {(() => { const Icon = timeline[activeTimeline].icon; return <Icon />; })()}
                  </div>
                  <p className={`text-xs font-bold uppercase tracking-widest ${timeline[activeTimeline].iconBg.split(" ")[1]}`}>
                    {timeline[activeTimeline].year} · {timeline[activeTimeline].label}
                  </p>
                  <h3 className="mt-2 text-2xl font-bold leading-snug">{timeline[activeTimeline].title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-slate-300">{timeline[activeTimeline].detail}</p>

                  <ul className="mt-5 flex flex-col gap-2">
                    {timeline[activeTimeline].highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2 text-sm text-slate-400">
                        <span className={`mt-1 h-1.5 w-1.5 shrink-0 rounded-full ${timeline[activeTimeline].dot}`} />
                        {h}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mt-8 flex items-center gap-3">
                  {timeline.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActiveTimeline(i)}
                      className={`h-1.5 rounded-full transition-all duration-300 ${
                        activeTimeline === i
                          ? `w-8 bg-gradient-to-r ${timeline[i].accent}`
                          : "w-2 bg-night-600 hover:bg-night-500"
                      }`}
                    />
                  ))}
                </div>
              </div>

              <div className="pointer-events-none absolute bottom-0 right-0 h-48 w-48 translate-x-12 translate-y-12 rounded-full bg-gradient-to-br from-brand-600/20 to-accent-500/10 blur-3xl" />
            </div>
          </div>
        </section>

        <section id="portfolio" className="scroll-mt-20 py-12">
          <h2 className="text-3xl font-bold">Projetos entregues</h2>
          <p className="mt-3 max-w-2xl text-slate-300">
            Produtos digitais reais, publicados e em uso — do briefing ao deploy, sempre com foco em resultado de negócio.
          </p>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            {portfolio.map((item) => (
              <article
                key={item.name}
                className="group flex flex-col overflow-hidden rounded-2xl border border-night-700 bg-night-800 transition hover:-translate-y-1 hover:border-accent-500/50 hover:shadow-xl hover:shadow-accent-900/20"
              >
                <div className="relative h-44 w-full overflow-hidden bg-night-900">
                  <div className="absolute inset-0 bg-gradient-to-br from-night-800 via-black to-night-900" />
                  <div className="absolute inset-0 flex items-center justify-center">
                      <div className="relative">
                        <div className={`absolute inset-0 rounded-[22%] ${item.glowColor} blur-2xl scale-125`} />
                        <div className={`relative h-24 w-24 rounded-[22%] overflow-hidden shadow-2xl shadow-black/70 transition group-hover:scale-110 ${item.iconBg}`}>
                          <img
                            src={item.thumb}
                            alt={item.name}
                            className={`h-full w-full ${item.thumbFit}`}
                          />
                        </div>
                      </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-night-900/90 to-transparent" />
                  <span className="absolute bottom-3 left-3 rounded-full border border-accent-400/40 bg-night-900/80 px-3 py-1 text-xs font-semibold text-accent-300 backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-start justify-between gap-2">
                    <h3 className="text-lg font-semibold text-white">{item.name}</h3>
                    {item.badge && (
                      <span className="shrink-0 rounded-full border border-yellow-400/40 bg-yellow-400/10 px-2 py-0.5 text-xs font-semibold text-yellow-300">
                        {item.badge}
                      </span>
                    )}
                  </div>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-300">{item.text}</p>

                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.stack.map((s) => (
                      <span
                        key={s}
                        className="rounded-full border border-night-700 bg-night-900/60 px-3 py-0.5 text-xs text-slate-400"
                      >
                        {s}
                      </span>
                    ))}
                  </div>

                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-4 flex items-center gap-2 text-sm font-semibold text-brand-300 transition hover:text-accent-300"
                  >
                    Visitar projeto
                    <span className="transition group-hover:translate-x-1">→</span>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="stack" className="scroll-mt-20 py-12">
          <h2 className="text-3xl font-bold">Stack técnica</h2>
          <p className="mt-3 max-w-2xl text-slate-300">
            Ferramentas escolhidas por performance, maturidade e resultado — do front-end ao back-end, passando por mobile, cloud e integrações de pagamento.
          </p>

          {(() => {
            const mainCats = stackCategories.slice(0, STACK_VISIBLE);
            const extraCats = stackCategories.slice(STACK_VISIBLE);

            const renderCats = (cats) =>
              cats.map((cat) => {
                const Icon0 = cat.items[0]?.icon;
                return (
                  <div key={cat.category}>
                    <div className="mb-4 flex items-center gap-3">
                      <span className={`inline-flex items-center gap-1.5 rounded-full border ${cat.border} bg-gradient-to-r ${cat.accent} px-3 py-1 text-xs font-semibold text-slate-200`}>
                        {Icon0 && <Icon0 className="text-sm" />}
                        {cat.category}
                      </span>
                      <div className="h-px flex-1 bg-night-700" />
                    </div>
                    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
                      {cat.items.map((tech) => {
                        const Icon = tech.icon;
                        return (
                          <article
                            key={tech.name}
                            className="group flex gap-4 rounded-2xl border border-night-700 bg-night-800/60 p-4 transition hover:-translate-y-0.5 hover:border-night-600 hover:bg-night-800"
                          >
                            <div className={`mt-0.5 shrink-0 text-3xl ${tech.color} transition group-hover:scale-110`}>
                              <Icon />
                            </div>
                            <div>
                              <h3 className="text-sm font-semibold text-white">{tech.name}</h3>
                              <p className="mt-1 text-xs leading-relaxed text-slate-400">{tech.desc}</p>
                            </div>
                          </article>
                        );
                      })}
                    </div>
                  </div>
                );
              });

            return (
              <div className="mt-10 space-y-10">
                {renderCats(mainCats)}

                <div
                  style={{ maxHeight: stackOpen ? "2000px" : "0px", overflow: "hidden", transition: "max-height 0.5s ease" }}
                >
                  <div className="space-y-10 pt-2">
                    {renderCats(extraCats)}
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="h-px flex-1 bg-night-700" />
                  <button
                    onClick={() => setStackOpen((v) => !v)}
                    className="flex items-center gap-2 rounded-full border border-brand-400/50 bg-brand-500/10 px-5 py-2 text-sm font-semibold text-brand-100 transition hover:border-accent-400 hover:bg-accent-500/10 hover:text-accent-200"
                  >
                    {stackOpen ? "Ver menos" : `Ver mais ${extraCats.length} categorias`}
                    <span
                      className="text-lg transition-transform duration-300"
                      style={{ display: "inline-block", transform: stackOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                    >
                      ↓
                    </span>
                  </button>
                  <div className="h-px flex-1 bg-night-700" />
                </div>
              </div>
            );
          })()}

          <div className="mt-8 rounded-2xl border border-brand-400/30 bg-gradient-to-r from-brand-700/20 via-night-800/40 to-accent-500/10 p-5">
            <p className="text-sm font-semibold text-brand-100">Metodologias e práticas</p>
            <p className="mt-2 text-sm text-slate-300">
              Trabalhamos com <span className="text-accent-300 font-medium">Scrum e Kanban</span> para entregas iterativas e previsíveis.
              Aplicamos <span className="text-accent-300 font-medium">TDD, BDD e SOLID</span> para garantir código testável, evolutivo e sem dívida técnica.
              Todo projeto passa por <span className="text-accent-300 font-medium">code review, testes automatizados e CI/CD</span> antes de ir para produção.
            </p>
          </div>
        </section>

        <section id="time" className="scroll-mt-20 py-12">
          <h2 className="text-3xl font-bold">Nosso time</h2>
            <p className="mt-3 max-w-2xl text-slate-300">
              Time enxuto, técnico e próximo do cliente — do levantamento de requisitos ao deploy em produção.
            </p>
          <div className="mt-8 grid gap-6 md:grid-cols-2">
            {team.map((person) => (
              <article
                key={person.name}
                className="group relative overflow-hidden rounded-2xl border border-night-700 bg-night-800 transition hover:border-accent-500/50"
              >
                <div className="absolute inset-0 -z-10 bg-gradient-to-b from-brand-600/10 via-transparent to-accent-500/5 opacity-0 transition group-hover:opacity-100" />
                <div className="flex items-center gap-4 border-b border-night-700 p-6">
                  <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-full border-2 border-brand-400/50">
                    <img
                      src={person.photo}
                      alt={person.name}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1">
                    <p className="text-lg font-semibold text-white">{person.name}</p>
                    <p className="text-sm text-accent-300">{person.role}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <a
                      href={person.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Instagram ${person.instagramHandle}`}
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-pink-500/30 bg-pink-500/10 text-pink-400 transition-all duration-200 hover:border-pink-400/60 hover:bg-pink-500/20 hover:text-pink-300"
                    >
                      <FaInstagram />
                    </a>
                    <a
                      href={person.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`GitHub ${person.githubHandle}`}
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-600/40 bg-slate-700/30 text-slate-400 transition-all duration-200 hover:border-slate-500/60 hover:bg-slate-700/60 hover:text-white"
                    >
                      <FaGithub />
                    </a>
                    <a
                      href={person.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="LinkedIn"
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-blue-500/30 bg-blue-500/10 text-blue-400 transition-all duration-200 hover:border-blue-400/60 hover:bg-blue-500/20 hover:text-blue-300"
                    >
                      <FaLinkedinIn />
                    </a>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-sm leading-relaxed text-slate-300">
                    <span className="text-brand-300 mr-1">&ldquo;</span>
                    {person.quote}
                    <span className="text-brand-300 ml-1">&rdquo;</span>
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-2">
                    {person.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full border border-night-700 bg-night-900/60 px-3 py-1 text-xs text-slate-400"
                      >
                        {tag}
                      </span>
                    ))}
                    <a
                      href="#stack"
                      className="ml-auto flex items-center gap-1 text-xs font-medium text-brand-300 transition-colors duration-200 hover:text-brand-200"
                    >
                      Ver stack completa
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section
          id="contato"
          className="scroll-mt-20 mt-8 rounded-3xl border border-brand-400/40 bg-gradient-to-r from-brand-700/35 via-night-700/60 to-accent-600/25 p-8 md:p-10"
        >
          <h2 className="bg-gradient-to-r from-white via-brand-100 to-accent-300 bg-clip-text text-3xl font-bold text-transparent">
            Pronto para construir sua próxima solução digital?
          </h2>
          <p className="mt-3 max-w-3xl text-slate-200">
            Receba uma proposta personalizada para desenvolvimento de software, sistema interno,
            plataforma web ou landing page de alta conversão.
          </p>
          <div className="mt-6 flex flex-wrap gap-4">
            <a
              className="rounded-full bg-gradient-to-r from-accent-400 to-accent-500 px-6 py-3 text-sm font-semibold text-night-900 transition hover:brightness-110"
              href="https://wa.me/559183423638"
              target="_blank"
              rel="noreferrer"
            >
              Chamar no WhatsApp
            </a>
            <a
              className="rounded-full border border-brand-300/70 px-6 py-3 text-sm font-semibold text-brand-100 transition hover:bg-brand-500/15 text-center"
              href="mailto:caienaestumanodevelopers@gmail.com"
            >
              <span className="hidden sm:inline">caienaestumanodevelopers@gmail.com</span>
              <span className="sm:hidden">Enviar e-mail</span>
            </a>
          </div>
          <div className="mt-6 grid gap-2 text-sm text-slate-200 sm:grid-cols-2">
            <a
              href="https://maps.google.com/?q=Ananindeua+PA"
              target="_blank"
              rel="noreferrer"
              className="rounded-xl border border-white/20 bg-white/5 px-4 py-3 transition hover:bg-white/10"
            >
              Endereço: Ananindeua - PA
            </a>
            <a
              href="tel:+559183423638"
              className="rounded-xl border border-white/20 bg-white/5 px-4 py-3 transition hover:bg-white/10"
            >
              Telefone: +55 (91) 8342-3638
            </a>
          </div>
        </section>

        <footer className="mt-16 border-t border-night-700/60">
          <div className="grid gap-10 py-12 md:grid-cols-4">

            <div className="md:col-span-1">
              <div className="group mb-4">
                <LogoAppIcon
                  src={logomark}
                  alt="Caiena e Estumano Developers"
                  className="h-[3.5rem] w-[3.5rem] sm:h-16 sm:w-16"
                />
              </div>
              <p className="text-sm leading-relaxed text-slate-400">
                Software house especializada em desenvolvimento web, mobile e sistemas sob medida.
              </p>
              <div className="mt-4 flex gap-3">
                <a href="https://www.instagram.com/caiena.dev/" target="_blank" rel="noopener noreferrer"
                  className="flex h-8 w-8 items-center justify-center rounded-full border border-night-700 bg-night-800 text-slate-400 transition hover:border-pink-500/50 hover:text-pink-400">
                  <FaInstagram className="text-sm" />
                </a>
                <a href="https://github.com/DCaiena" target="_blank" rel="noopener noreferrer"
                  className="flex h-8 w-8 items-center justify-center rounded-full border border-night-700 bg-night-800 text-slate-400 transition hover:border-slate-400 hover:text-white">
                  <FaGithub className="text-sm" />
                </a>
                <a href="https://www.linkedin.com/in/diegocaiena" target="_blank" rel="noopener noreferrer"
                  className="flex h-8 w-8 items-center justify-center rounded-full border border-night-700 bg-night-800 text-slate-400 transition hover:border-blue-500/50 hover:text-blue-400">
                  <FaLinkedinIn className="text-sm" />
                </a>
              </div>
            </div>

            <div>
              <p className="mb-4 text-xs font-bold uppercase tracking-widest text-slate-500">Navegação</p>
              <ul className="flex flex-col gap-2 text-sm text-slate-400">
                {[
                  { label: "Serviços", href: "#servicos" },
                  { label: "Para quem é", href: "#processo" },
                  { label: "Portfólio", href: "#portfolio" },
                  { label: "Stack técnica", href: "#stack" },
                  { label: "Nosso time", href: "#time" },
                  { label: "Contato", href: "#contato" },
                ].map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="transition hover:text-white">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="mb-4 text-xs font-bold uppercase tracking-widest text-slate-500">Empresa</p>
              <ul className="flex flex-col gap-2 text-sm text-slate-400">
                <li>CNPJ: 66.113.830/0001-33</li>
                <li>Nome fantasia: Caiena &amp; Estumano Developers</li>
                <li>Fundação: 2026</li>
                <li>Ananindeua — PA, Brasil</li>
                <li className="pt-1">
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-green-500/40 bg-green-500/10 px-2.5 py-0.5 text-xs font-semibold text-green-400">
                    <span className="h-1.5 w-1.5 rounded-full bg-green-400" />
                    CNPJ ativo
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <p className="mb-4 text-xs font-bold uppercase tracking-widest text-slate-500">Contato</p>
              <ul className="flex flex-col gap-3 text-sm text-slate-400">
                <li>
                  <a href="https://wa.me/559183423638" target="_blank" rel="noreferrer"
                    className="flex items-center gap-2 transition hover:text-white">
                    <span className="text-green-400">💬</span> WhatsApp: (91) 9 8342-3638
                  </a>
                </li>
                <li>
                  <a href="mailto:caienaestumanodevelopers@gmail.com"
                    className="flex items-center gap-2 transition hover:text-white">
                    <span>✉️</span> caienaestumanodevelopers@gmail.com
                  </a>
                </li>
                <li>
                  <a href="https://maps.google.com/?q=Ananindeua+PA" target="_blank" rel="noreferrer"
                    className="flex items-center gap-2 transition hover:text-white">
                    <span>📍</span> Ananindeua, Pará — Brasil
                  </a>
                </li>
              </ul>
              <div className="mt-5 rounded-xl border border-accent-400/20 bg-accent-500/5 px-4 py-3">
                <p className="text-xs font-semibold text-accent-300">Aceitando novos projetos</p>
                <p className="mt-0.5 text-xs text-slate-500">Retorno em até 24h úteis.</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-between gap-3 border-t border-night-700/60 py-6 text-xs text-slate-500 sm:flex-row">
            <span>© 2026 CAIENA &amp; ESTUMANO DEVELOPERS. Todos os direitos reservados.</span>
            <span className="flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
              Feito com dedicação em Ananindeua, PA
            </span>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;
